import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import type { CommerceMoney } from "@teqtank/commerce-sdk";

@customElement("teqtank-price")
export class TeqtankPrice extends LitElement {
    @property({ attribute: false }) public accessor value: CommerceMoney | undefined;
    public static override styles = css`
        :host {
            display: inline;
            font: inherit;
        }
        .price {
            font-variant-numeric: tabular-nums;
        }
    `;
    protected override render() {
        return html`<span class="price" part="price">${this.value?.formatted ?? "—"}</span>`;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        "teqtank-price": TeqtankPrice;
    }
}
